import { useContext, useState, useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { AccountContext } from "./context/AccountContext";
import Loading from "./components/Loading/Loading";
import { TARM_AWS_URL } from "./api/api";

const RequireAuth = () => {
  const [status, setStatus] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const { getSession, authToken } = useContext(AccountContext);
  const location = useLocation();
  const navigate = useNavigate();

  // // Request interceptor
  TARM_AWS_URL.interceptors.request.use(
    (config) => {
      // console.log(authToken)
      if (authToken) {
        config.headers.common['Authorization'] = authToken;
      }
      // console.log('Request sent:', config);
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );



  TARM_AWS_URL.interceptors.response.use(
    (response) => {
      // console.log('Response sent:', response);
      return response;
    }, error => {
      console.log(error)
      console.log(isNetworkError(error))
      return Promise.reject(error);
    }

  )

  const isNetworkError = (err) => {
    return !!err.isAxiosError && !err.response;
  }

  useEffect(() => {
    getSession()
      .then((session) => {
        // console.log("Session:", session);
        setStatus(true);
        setLoading(false);
      })
      .catch((err) => {
        setStatus(false);
        setLoading(false);
        console.log(err);
        navigate("/");
      });
  }, [location]);

  return isLoading ? (
    <Loading loading={isLoading} />
  ) : status ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} replace />
  );
};

export default RequireAuth;
